import type { OrthosApi } from "../types";
import { projectFileCount } from "./file-count";

/**
 * The demo projects invent a file count, while the Files page lists what the files backend really holds, so the
 * sidebar said "Files 5" over "0 of 0 files". This takes the stored files' count from the files backend and adds the
 * project's drawings, as live mode does (`toDetail`), so the sidebar, the first steps and the Files page agree. A
 * failed count is 0 stored files.
 */
export function withRealFileCount(
  api: OrthosApi,
  fileCount: (projectId: string) => Promise<number>,
): OrthosApi {
  return {
    ...api,
    async getProject(id) {
      const [detail, count] = await Promise.all([api.getProject(id), fileCount(id).catch(() => 0)]);
      return { ...detail, fileCount: projectFileCount(detail.drawings.length, count) };
    },
  };
}
